// DO NOT CHANGE THESE NAMES!! They are referenced in the database
// as identifiers for template images
const TEMPLATE_IMAGE_ASSET_KEYS = ['CAMERA', 'GAME', 'TV'] as const

export type TemplateImageAsset = (typeof TEMPLATE_IMAGE_ASSET_KEYS)[number]

export function isTemplateImageAsset(
  value: string,
): value is TemplateImageAsset {
  return TEMPLATE_IMAGE_ASSET_KEYS.includes(value as TemplateImageAsset)
}
